import { useState } from 'react';
import { getPasswordReset, resetPassword } from '../../lib/allauth';
import { Navigate, Link, useLoaderData } from 'react-router-dom';
import { Button, Box, Typography, TextField } from '@mui/material';
import { fontSize, styled } from '@mui/system';

import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseTextField from '../../components/BaseTextField';
import BaseFormContainer from '../../components/BaseFormContainer';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});
export async function loader({ params }) {
  const key = params.key;
  const resp = await getPasswordReset(key);
  return { key, keyResponse: resp };
}

export default function ResetPassword() {
  const { key, keyResponse } = useLoaderData();
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [password2Errors, setPassword2Errors] = useState([]);
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    if (password2 !== password1) {
      setPassword2Errors([{ param: 'password2', message: 'Passwords do not match.' }]);
      return;
    }
    setPassword2Errors([]);
    setResponse({ ...response, fetching: true });
    resetPassword({ key, password: password1 })
      .then((resp) => setResponse((r) => ({ ...r, content: resp })))
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .finally(() => setResponse((r) => ({ ...r, fetching: false })));
  }

  if ([200, 401].includes(response.content?.status)) {
    return <Navigate to='/account/login' />;
  }

  let body;
  if (keyResponse.status !== 200) {
    body = <Typography color='error'>Invalid or expired reset key.</Typography>;
  } else {
    body = (
      <>
        <BaseTextField
          label='New Password'
          type='password'
          autoComplete='new-password'
          value={password1}
          onChange={(e) => setPassword1(e.target.value)}
          required
        />
        <BaseTextField
          label='Confirm Password'
          type='password'
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          required
          error={password2Errors.length > 0}
          helperText={password2Errors.length > 0 ? password2Errors[0].message : ''}
        />
        <BaseButton disabled={response.fetching} onClick={submit}>Reset Password</BaseButton>
      </>
    );
  }

  return (
    <BackgroundContainer>
      <BaseFormContainer sx={{
    width: '100%',
    padding: { xs: 2, sm: 3 },
    boxSizing: 'border-box',
    marginBottom: '20px',}}>
      <BaseHeader sx={{
          fontSize: '4rem', // 🎯 Full size title
          '@media (max-width: 360px)': {
            fontSize: '3.8rem', // 🧠 Gentle scale-down on ultra-small screens
          },
          '@media (max-width: 320px)': {
            fontSize: '3rem', // 🔒 Last-resort fallback for smallest devices
            lineHeight: '1.1',
          },
          textAlign: 'center', // (optional) center if you want
        }} >Reset Your Password</BaseHeader>
      <Subtitle sx={{fontSize: '1.8rem',marginBottom: '20px'}} color='rgba(216, 175, 206, 0.7)'>Enter your new password below.</Subtitle>
      {body}
      <Subtitle sx={{ fontSize: '1.3rem', marginTop: '20px', color: 'rgba(255, 255, 255, 0.7)' }}>
        Remember your password? <Link to='/login' style={{ color: '#E91E63', fontWeight: 'bold' }}>Back to Login</Link>
      </Subtitle>
      </BaseFormContainer>
    </BackgroundContainer>
  );
}
